import post from '../post/post-proxy'

export default {
  /**
   * /ygst/exception/count/get 根据食堂id获取异常总数
   * @param departmentId
   */
  exceptionCountGet: departmentId => post('swagger', '/ygst/exception/count/get', {departmentId}),
  /**
   * /ygst/region/exception/list/get 根据区域id获取异常信息
   * @param regionId
   * @param page
   * @param pageSize
   */
  yiChangXXGet: (page, pageSize, regionId) => post('swaggerSB', '/ygst/region/exception/list/get', {page, pageSize, regionId}),
  /**
   * /ygst/exception/today/list/get 根据区域分页获取当天异常记录
   * @param regionId
   * @param page
   * @param pageSize
   */
  todayYiChangXXGet: ({page, pageSize, regionId}) => {
    let params = {
      page,
      pageSize,
      regionId
    }
    return post('swaggerSB', '/ygst/exception/today/list/get', params)
  },
  /**
   * /ygst/exception/history/list/get 获取历史异常记录
   * @param beginTime
   * @param departmentId
   * @param endTime
   * @param regionId
   * @param page
   * @param pageSize
   */
  exceptionHistoryListGet: ({beginTime, departmentId, endTime, page, pageSize, regionId}) => {
    let params = {
      departmentId,
      page,
      pageSize
    }
    if (beginTime) {
      params.beginTime = beginTime
    }
    if (endTime) {
      params.endTime = endTime
    }
    if (regionId) {
      params.regionId = regionId
    }
    return post('swaggerSB', '/ygst/exception/history/list/get', params)
  },
  /**
   * /ygst/region/list/get 获取区域列表
   * @param departmentId
   */
  quYuListGet: departmentId => post('swagger', '/ygst/region/list/get', {departmentId}),
  /**
   * /ygst/region/list/get 获取区域列表2.0版本
   */
  noconditionListGet: () => post('swagger', '/ygst/region/nocondition/list/get', {}),
  /**
   * /ygst/employee/onpost/list/get 根据食堂编号获取在岗人员
   * @param departmentId
   */
  onpostListGet: departmentId => post('swagger', '/ygst/employee/onpost/list/get', {departmentId}),
  /**
   * /ygst/employee/onpost/deptcontra/list/get 根据食堂编号、承包商ID获取在岗人员
   * @param departmentId 食堂编号
   * @param contractorId 承包商id
   */
  onpostDeptConListGet: ({contractorId, departmentId}) => {
    let params = {
      contractorId,
      departmentId
    }
    return post('swagger', '/ygst/employee/onpost/deptcontra/list/get', params)
  },
  /**
   * /device/device/list 获取冰箱消毒柜列表
   */
  deviceListGet: () => post('swaggerSB', '/ygst/device/device/list', {}),
  /**
   * /ygst/device/voltage/24/get 24小时功率变化
   */
  voltage24Get: ({deviceId, monltorTime}) => post('swaggerSB', '/ygst/device/voltage/24/get', {deviceId, monltorTime}),
  /**
   * /ygst/device/water/all/24/get 24小时总用水变化
   */
  waterAll24Get: ({departmentId, monltorTime}) => post('swaggerSB', '/ygst/device/water/all/24/get', {departmentId, monltorTime}),
  /**
   * /ygst/device/water/24/get 24小时用水变化
   */
  water24Get: ({deviceId, monltorTime}) => post('swaggerSB', '/ygst/device/water/24/get', {deviceId, monltorTime}),
  /**
   * /ygst/region/exception/info/get 获取异常信息详情
   * @param exceptionId
   */
  // regionExceptionInfoGet: exceptionId => post('swaggerSB', '/ygst/region/exception/info/get', {exceptionId}),
  /**
   * /ygst/pc/goods/today/list/get 获取今日入库食品列表(ndj)
   * @param departmentId
   */
  goodsTodayListGet: departmentId => post('swagger', '/ygst/pc/goods/today/list/get', {departmentId}),
  /**
   * /ygst/region/storage/info/get 获取仓库区负责人（ndj）
   * @param departmentId
   */
  regionStorageInfoGet: departmentId => post('swagger', '/ygst/region/storage/info/get', {departmentId}),
  /**
   * /ygst/accompany/schedule/today/leadinfo 获取今日陪餐领导
   * @param departmentId
   */
  scheduleTodayLeadinfo: departmentId => post('swagger', '/ygst/accompany/schedule/today/leadinfo', {departmentId}),
  /**
   * /ygst/device/electric/all/24/get 获取24小时总用电变化
   * @param departmentId
   * @param monltorTime
   */
  energy24Get: ({departmentId, monltorTime}) => post('swaggerSB', '/ygst/device/electric/all/24/get', {departmentId, monltorTime}),
  /**
   * /ygst/device/electric/24/get 24小时用电变化
   * @param deviceId
   * @param monltorTime
   */
  deviceElectric24Get: ({deviceId, monltorTime}) => post('swaggerSB', '/ygst/device/electric/24/get', {deviceId, monltorTime}),
  /**
   * /ygst/device/temperature/humidity/24/get 24小时温湿度变化
   * @param deviceId
   * @param monltorTime
   */
  humidity24Get: ({deviceId, monltorTime}) => post('swaggerSB', '/ygst/device/temperature/humidity/24/get', {deviceId, monltorTime}),
  /**
   * @description: 24小时空气质量变化
   * @author: linwen linwen@fjxhx.com
   * @createDate: 2020-10-13 17:39
   * @param: deviceId 设备ID
   * @param: monltorTime 监测日期
   * @return:
  */
  deviceAirQuality24Get: ({deviceId, monltorTime}) => post('swaggerSB', '/ygst/device/air/quality/24/get', {deviceId, monltorTime}),
  /**
   * @description: 臭氧
   * @author: linwen linwen@fjxhx.com
   * @createDate: 2020-10-14 19:37
   * @param: 臭氧
   * @return:
  */
  deviceOzone24Get: ({deviceId, monltorTime}) => post('swaggerSB', '/ygst/device/ozone/24/get', {deviceId, monltorTime}),
  /**
   * /ygst/pc/device/list/get 获取设备列表(地图显示)
   * @param departmentId
   */
  pcDeviceListGet: ({departmentId}) => post('swaggerSB', '/ygst/pc/device/list/get', {departmentId}),
  /**
   * /ygst/camera/homepage/list/get 首页获取摄像头列表(ndj)
   * @param departmentId
   */
  cameraHomepageListGet: ({departmentId}) => post('swaggerSB', '/ygst/camera/homepage/list/get', {departmentId}),
  /**
   * /ygst/fridge/record/list/get 留样冰箱开启记录列表
   * @param departmentId
   * @param deviceId
   * @param page
   * @param pageSize
   * @param time
   */
  fridgeRecordListGet: ({departmentId, deviceId, page, pageSize, time}) => {
    let params = {
      departmentId,
      deviceId,
      page,
      pageSize
    }
    if (time) {
      params.time = time
    }
    return post('swaggerSB', '/ygst/fridge/record/list/get', params)
  },
  /**
   * /ygst/device/default/list 温湿度和总能耗设备初始化列表
   * @param departmentId
   */
  deviceDefaultList: ({departmentId}) => post('swaggerSB', '/ygst/device/default/list', {departmentId}),
  /**
   * /ygst/pc/goods/today/purchase/get 获取今日采购公示
   * @param departmentId
   * @param orgId
   */
  todaypurchaseGet: ({departmentId, orgId}) => {
    let params = {
      departmentId,
      orgId
    }
    return post('swagger', '/ygst/pc/goods/today/purchase/get', params)
  },
  /**
   * /ygst/pc/goods/today/detail/list/get 根据供应商id获取今日采购明细(ndj)
   * @param supplierId
   */
  todayDetailListGet: supplierId => post('swagger', '/ygst/pc/goods/today/detail/list/get', {supplierId}),
  /**
   * /ygst/pc/supplier/get 查看采购凭证详情
   * @param batchId
   * @param supplierId
   */
  supplierGet: ({batchId, supplierId}) => post('swagger', '/ygst/pc/supplier/get', {batchId, supplierId}),
  /**
   * /ygst/exception/explanation/info/get 获取异常处置信息
   * @param exceptionId
   */
  exceptionExplanationInfoGet: exceptionId => post('swaggerSB', '/ygst/exception/explanation/info/get', {exceptionId}),
  /**
   * /ygst/exception/info/update 处置异常信息
   * @param exceptionId
   * @param explanation
   * @param fileList
   */
  exceptionInfoUpdate: ({exceptionId, explanation, fileList}) => {
    let params = {
      exceptionId,
      explanation
    }
    if (fileList) {
      params.fileList = fileList
    }
    return post('swaggerSB', '/ygst/exception/info/update', params)
  },
  /**
   * /ygst/detection/record/list/get 农残检测记录列表获取
   * @param departmentId
   * @param page
   * @param pageSize
   * @param sampleName
   * @param beginDate
   * @param endDate
   */
  detectionRecordListGet: ({departmentId, page, pageSize, sampleName, beginDate, endDate}) => {
    let params = {
      departmentId,
      page,
      pageSize
    }
    if (sampleName) {
      params.sampleName = sampleName
    }
    if (beginDate) {
      params.beginDate = beginDate
    }
    if (endDate) {
      params.endDate = endDate
    }
    return post('swaggerSB', '/ygst/detection/record/list/get', params)
  },
  /**
   * /ygst/exception/energy/total/list/get 获取食堂总能耗异常记录
   * @param departmentId
   * @param exceptionType
   * @param page
   * @param pageSize
   * @param time
   */
  exceptionEnergyTotalListGet: ({departmentId, exceptionType, page, pageSize, time}) => {
    let params = {
      departmentId,
      exceptionType,
      page,
      pageSize,
      time
    }
    return post('swaggerSB', '/ygst/exception/energy/total/list/get', params)
  },
  /**
   * /ygst/exception/device/list/get 根据设备ID获取设备异常记录
   * @param departmentId
   * @param deviceId
   * @param page
   * @param pageSize
   * @param time
   */
  exceptionDeviceListGet: ({departmentId, deviceId, page, pageSize, time}) => {
    let params = {
      departmentId,
      deviceId,
      page,
      pageSize
    }
    if (time) {
      params.time = time
    }
    return post('swaggerSB', '/ygst/exception/device/list/get', params)
  },
  /**
   * /ygst/energy/setting/get 获取电源/水能异常监测设置信息列表
   * @param deviceId
   */
  energySettingGet: ({deviceId}) => post('swaggerSB', '/ygst/energy/setting/get', {deviceId}),
  /**
   * /ygst/energy/setting/elec/get 获取电能异常监测设置信息列表
   * @param departmentId
   */
  energySettingElecGet: ({departmentId}) => post('swaggerSB', '/ygst/energy/setting/elec/get', {departmentId}),
  /**
   * /file/exception/prtscreen/list/get 获取电能异常监测设置信息列表
   * @param targetId
   */
  fileHandleListGet: ({targetId}) => post('swaggerSB', '/file/exception/prtscreen/list/get', {targetId}),
  /**
   * 食堂设备总览
   * @author: whl
   * @param departmentId
   * @createDate: 2019/9/9
   */
  assetStatistics({departmentId}) {
    var params = {departmentId} // 必填项
    return post('swagger', '/ygst/asset/statistics', params)
  },
  /**
   * 根据主键获取周边商家信息(liurl)
   * @author: whl
   * @param peripheralId
   * @createDate: 2019/9/9
   */
  peripheralFoodShopGet({peripheralId}) {
    var params = {peripheralId} // 必填项
    return post('swagger', '/ygst/peripheral/food/shop/get', params)
  },
  /**
   * 获取指示灯异常总数
   * @author: whl
   * @param departmentId
   * @createDate: 2019/9/12
   */
  exceptionLightTotalGet({departmentId}) {
    let params = {departmentId} // 必填项
    return post('swaggerSB', '/ygst/exception/light/total/get', params)
  },
  /**
   * 查看食堂安全人员配置(包含头像)(wzp)
   * @author: whl
   * @param departmentId
   * @param orgId
   * @createDate: 2019/9/9
   */
  deptsafeconfigImgGet({departmentId, orgId}) {
    let params = {
      departmentId: departmentId,
      orgId: orgId
    }
    return post('swagger', '/ygst/deptsafeconfig/img/get', params)
  },
  /**
   * @Description: 根据人员id获取人员基础信息
   * @author kk
   * @date 2019/11/5
   */
  personInfoGet: (deptId, userId) => {
    return post('swagger', '/ygst/deptsafeconfig/pc/get', {
      'departmentId': deptId,
      'userId': userId
    })
  },
  /**
   * @Description: 获取巡检清单数目
   * @author kk
   * @date 2019/11/6
   */
  getCheckListNum: ({departmentId, orgId}) => {
    return post('swagger', '/ygst/inspectmenu/dept/get', {
      'departmentId': departmentId,
      'orgId': orgId
    })
  },
  /**
   * @Description: 获取日巡检清单列表
   * @author kk
   * @date 2019/11/7
  */
  getCheckList: id => {
    return post('swagger', '/ygst/inspectmenu/item/list/get', {
      'inspectMenuId': id
    })
  },
  /**
   * @Description:获取食堂规章制度
   * @author kk
   * @date 2019/11/8
  */
  getRegulationInfo: orgId => {
    return post('swagger', '/ygst/regulation/get', {
      'orgId': orgId
    })
  },
  /**
   * @Description:食堂管理获取食堂列表(wzp)
   * @author wanghongling
   * @createDate 2019/12/3/ygst/dept/list/get
   */
  deptListGet: ({departmentId, departmentName, orgId}) => {
    let params = {
      'orgId': orgId
    } // 必填项
    if (departmentId) {
      params.departmentId = departmentId
    }
    if (departmentName) {
      params.departmentName = departmentName
    }
    return post('swagger', '/ygst/dept/list/get', params)
  },
  /**
   * @Description:PC端获取食堂视图显示权限(wzp)
   * @author wanghongling
   * @createDate 2019/12/3
   */
  deptPowerGet: ({departmentId}) => {
    let params = {
      'departmentId': departmentId
    } // 必填项
    return post('swagger', '/ygst/dept/pc/power/get', params)
  },
  /**
   * @Description:食堂管理获取食堂列表(wzp)
   * @author wanghongling
   * @createDate 2019/12/3
   */
  contraListGet: ({departmentId}) => {
    let params = {
      departmentId: departmentId
    }
    return post('swagger', '/ygst/constramanage/contra/list/get', params)
  },
  /**
   * @Description:根据食堂获取基础设备和摄像头坐标（食堂预览）(wzp)
   * @author wanghongling
   * @createDate 2019/12/3
   */
  deviceXYListGet: ({departmentId}) => {
    let params = {
      departmentId: departmentId
    }
    return post('swaggerSB', '/ygst/device/xy/list/get', params)
  },
  /**
   * @Description:根据区域和食堂ID分页获取当天异常记录
   * @author wanghongling
   * @createDate 2019/12/3
   */
  todayRegiondeptListGet: ({departmentId, page, pageSize, regionId}) => {
    let params = {
      departmentId: departmentId,
      page: page,
      pageSize: pageSize,
      regionId: regionId
    }
    return post('swaggerSB', '/ygst/exception/today/regiondept/list/get', params)
  },
  /**
   * @Description:大屏显示-食堂-点击晨检设备显示体温检测记录（wzp）
   * @author wanghongling
   * @createDate 2019/12/3
   */
  deviceTemperatureGet: ({deviceId, occurDate, page, pageSize, temparatureStatus, userName}) => {
    let params = {
      deviceId: deviceId,
      occurDate: occurDate,
      page: page,
      pageSize: pageSize
    }
    if (temparatureStatus) {
      params.temparatureStatus = temparatureStatus
    }
    if (userName) {
      params.userName = userName
    }
    return post('swagger', '/ygst/pc/health/dept/device/temperature', params)
  },
  /**
   * @Description:大屏-第一食堂-食品快检记录分页列表(wzp)
   * @author wanghongling
   * @createDate 2019/12/3
   */
  resultListGet: ({departmentId, page, pageSize, beginTime, endTime, goodsName}) => {
    let params = {
      departmentId: departmentId,
      page: page,
      pageSize: pageSize
    }
    if (beginTime) {
      params.beginTime = beginTime
    }
    if (endTime) {
      params.endTime = endTime
    }
    if (goodsName) {
      params.goodsName = goodsName
    }
    return post('swagger', '/ygst/detect/pc/result/list/get', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/shitang.js